import type { ConnectorChannelType } from "#types/types.ts";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface DisabledChannelsStore {
    disabledChannels: ConnectorChannelType[];
    toggleChannel: (channel: ConnectorChannelType) => void;
}

export const useDisabledChannelsStore = create<DisabledChannelsStore>()(persist(set => ({
    disabledChannels: [],
    toggleChannel: channel => set(state => ({
        disabledChannels: state.disabledChannels.includes(channel)
            ? state.disabledChannels.filter(ch => ch !== channel)
            : [...state.disabledChannels, channel]
    }))
}), {
    name: "disabled-channels",
    storage: createJSONStorage(() => localStorage)
}));
